/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useRef,
  useEffect,
  createContext,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import SVGPreview from './SVGPreview';
import ChameleonsImagePreview, { SVG } from './ChameleonsImagePreview';
import Search from '../Search';
import PrevNextPage from '../PrevNextPage';
import variables from '../variables';
import { useQuery, Query } from 'urql';
import gql from 'graphql-tag';
import LoadMore from '../LoadMore';
import { ImageLibraryContext } from '../../EditImage';

const { thumbnailsContainerHeight } = variables;

const ESVGQuery = gql`
  query eql($tags: String, $page: Int, $per: Int) {
    esvgs(tags: $tags, page: $page, per: $per) {
      data {
        id
        label
        url
        createdAt
        tags
      }
      meta {
        totalCount
        totalPages
        currentPage
        perPage
      }
    }
  }
`;

const ChameleonsLibraryContext = createContext<any>(undefined);

const URL_PREFIX = window['chameleon'].CHAMELEON_URL;
//  || 'https://chameleon-development.herokuapp.com/';

const cache = {};

let cacheSelected = 0;
let cachedSearch;
let svgs;

const ChameleonsLibrary = () => {
  const { cacheSelected } = useContext(ImageLibraryContext)!;

  const [selected, setSelected] = useState(cacheSelected!.chameleonsLibrary);
  const [previewData, setPreviewData] = useState(null);

  const [tags, setTags] = useState(cachedSearch);
  const [page, setPage] = useState(1);
  const [per, setPer] = useState(100);
  // const tags = useRef('');

  const [res, reload] = useQuery({
    query: ESVGQuery,
    variables: {
      // tags: tags.current,
      tags,
      page,
      per,
    },
    requestPolicy: 'cache-and-network',
  });

  let meta: any = {};

  if (res.data) {
    svgs = res.data.esvgs.data.map((entry: any) => entry);
    meta = res.data.esvgs.meta;
  }

  const isMore = false; // meta.totalCount && per < meta.totalCount;

  useEffect(() => {
    if (svgs && !previewData) {
      setPreviewData(svgs[cacheSelected!.chameleonsLibrary]);
    }
  });


  const onSetSelected = (index, src) => {
    setSelected((cacheSelected!.chameleonsLibrary = index));
    setPreviewData(src);
  };

  return (
    <ChameleonsLibraryContext.Provider
      value={{
        cache,
        updateCache(src, svgDOM) {
          return (cache[src] = svgDOM);
        },
      }}
    >
      <div
        css={css`
          position: relative;
          display: flex;
          width: 100%;
          height: 100%;
        `}
      >
        <div
          css={css`
            flex: 1;
            padding: 0 5px 0 0;
          `}
        >
          {previewData && (
            <SVGPreview
              // key={tags}
              src={`${URL_PREFIX}${(previewData as any).url}`}
              label={(previewData as any).label}
            />
          )}
        </div>

        <div
          css={css`
            position: relative;
            flex: 2;
            padding: 10px 20px ${isMore ? 25 : 10}px 20px;
            background: #eaefff;
          `}
        >
          <Search
            defaultValue={cachedSearch}
            onSearch={value => {
              setTags((cachedSearch = value));
              onSetSelected(0, svgs[0]);
            }}
          />

          <div
            css={css`
              position: relative;
              height: ${thumbnailsContainerHeight()};
              overflow-y: auto;
            `}
          >
            <div
              css={css`
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(155px, 1fr));
              `}
            >
              {svgs &&
                svgs.map((entry: any, i) => {
                  const src = `${URL_PREFIX}${entry.url}`;
                  const label = entry.label;

                  return (
                    <ChameleonsImagePreview
                      key={`thumbnail${i}`}
                      src={src}
                      label={label}
                      selected={selected === i}
                      onClick={() => onSetSelected(i, entry)}
                      color="#61cece"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </ChameleonsLibraryContext.Provider>
  );
};

export default ChameleonsLibrary;
export { ChameleonsLibraryContext };
